var map = {
	"./bitgetArrow.png": 4616,
	"./bitgetHomeBanner.png": 88,
	"./blueBg.png": 6789,
	"./buyWodBanner.png": 9444,
	"./chestImages/chest0.png": 3497,
	"./chestImages/chest0open.png": 6609,
	"./chestImages/chest1.png": 7248,
	"./chestImages/chest10.png": 8978,
	"./chestImages/chest10open.png": 982,
	"./chestImages/chest11.png": 6843,
	"./chestImages/chest11open.png": 6571,
	"./chestImages/chest1open.png": 5684,
	"./chestImages/chest2.png": 4891,
	"./chestImages/chest2open.png": 9147,
	"./chestImages/chest3.png": 3762,
	"./chestImages/chest3open.png": 2742,
	"./chestImages/chest4.png": 1661,
	"./chestImages/chest4open.png": 2093,
	"./chestImages/chest5.png": 4980,
	"./chestImages/chest5open.png": 5040,
	"./chestImages/chest6.png": 9471,
	"./chestImages/chest6open.png": 5191,
	"./chestImages/chest7.png": 454,
	"./chestImages/chest7open.png": 8914,
	"./chestImages/chest8.png": 5649,
	"./chestImages/chest8open.png": 6121,
	"./chestImages/chest9.png": 4520,
	"./chestImages/chest9open.png": 5500,
	"./craze.png": 7729,
	"./crazeToken.png": 4978,
	"./dailySession/calendar.png": 4144,
	"./dailySession/coin.png": 1905,
	"./dailySession/completedSessionBg.png": 2698,
	"./dailySession/completedSeven.png": 144,
	"./dailySession/fire.png": 9718,
	"./dummyBanner.png": 5560,
	"./earnAssets/dummyPartner.png": 5036,
	"./earnAssets/open_chest.png": 4344,
	"./earnAssets/sandTimer.png": 8357,
	"./getStartedBg.png": 2834,
	"./getStartedWod.png": 5417,
	"./giftBox.png": 6671,
	"./mainBg.png": 4510,
	"./openChestBanner.png": 5111,
	"./open_chest.png": 4446,
	"./playBanner.png": 8000,
	"./scoreBg.png": 6045,
	"./socialBanner.png": 4695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;